/**
 * Segment de titre d’onglet : décode les entités HTML puis applique htmlToPlainText.
 * Utile quand la source contient du rich text (`<p>…</p>`) ou des entités (`&lt;font…`).
 */
export function toPlainDocumentTitleSegment(input: string | undefined | null): string {
  if (input == null || typeof input !== 'string') return '';
  let s = input.trim();
  if (!s) return '';
  if (typeof document !== 'undefined') {
    const ta = document.createElement('textarea');
    ta.innerHTML = s;
    s = ta.value;
  } else {
    s = s
      .replace(/&nbsp;/gi, ' ')
      .replace(/&lt;/g, '<')
      .replace(/&gt;/g, '>')
      .replace(/&quot;/g, '"')
      .replace(/&#0*39;|&apos;/gi, "'")
      .replace(/&amp;/g, '&');
  }
  return htmlToPlainText(s);
}

/** Extrait un texte lisible depuis du HTML (description de bloc, etc.). */
export function htmlToPlainText(html: string | undefined | null): string {
  if (html == null || typeof html !== 'string') return '';
  return html
    .replace(/<script[\s\S]*?<\/script>/gi, '')
    .replace(/<style[\s\S]*?<\/style>/gi, '')
    .replace(/<br\s*\/?>/gi, '\n')
    .replace(/<\/p>/gi, '\n')
    .replace(/<\/div>/gi, '\n')
    .replace(/<\/li>/gi, '\n')
    .replace(/<[^>]+>/g, ' ')
    .replace(/&nbsp;/gi, ' ')
    .replace(/&amp;/g, '&')
    .replace(/&lt;/g, '<')
    .replace(/&gt;/g, '>')
    .replace(/&#39;/g, "'")
    .replace(/&quot;/g, '"')
    .replace(/\s+/g, ' ')
    .trim();
}

/**
 * Texte brut pour téléprompteur : pas de mise en forme, images/svg/icônes retirés,
 * espaces normalisés par ligne, retours à la ligne conservés.
 */
export function htmlToTeleprompterPlainText(html: string | undefined | null): string {
  if (html == null || typeof html !== 'string') return '';
  let s = html
    .replace(/<script[\s\S]*?<\/script>/gi, '')
    .replace(/<style[\s\S]*?<\/style>/gi, '');
  // Retirer médias / pictos courants dans le HTML éditeur
  s = s
    .replace(/<svg[\s\S]*?<\/svg>/gi, '')
    .replace(/<img[^>]*>/gi, '')
    .replace(/<picture[\s\S]*?<\/picture>/gi, '')
    .replace(/<figure[\s\S]*?<\/figure>/gi, '\n')
    .replace(/<i[^>]*class="[^"]*lucide[^"]*"[\s\S]*?<\/i>/gi, '')
    .replace(/<span[^>]*class="[^"]*icon[^"]*"[\s\S]*?<\/span>/gi, '');
  // </p>, titres, blockquote → séparation de paragraphe (double saut) pour le téléprompteur
  s = s
    .replace(/<br\s*\/?>/gi, '\n')
    .replace(/<\/(p|h[1-6]|blockquote)\s*>/gi, '\n\n')
    .replace(/<\/(div|li|tr|section|article|header|footer|pre)\s*>/gi, '\n')
    .replace(/<(p|div|h[1-6]|tr|blockquote|section|article|header|footer|pre)[^>]*>/gi, '\n');
  s = s.replace(/<[^>]+>/g, ' ');
  s = s
    .replace(/&nbsp;/gi, ' ')
    .replace(/&amp;/g, '&')
    .replace(/&lt;/g, '<')
    .replace(/&gt;/g, '>')
    .replace(/&#39;/g, "'")
    .replace(/&quot;/g, '"');
  s = s
    .split('\n')
    .map((line) => line.replace(/[ \t\f\v]+/g, ' ').replace(/\u00a0/g, ' ').trimEnd())
    .join('\n');
  s = s.replace(/\n{3,}/g, '\n\n');
  return s.trim();
}
